/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventcanceled1Inputs */

const en_eventcanceled1 = /** @type {(inputs: Eventcanceled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event canceled`)
};

const de_eventcanceled1 = /** @type {(inputs: Eventcanceled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event abgesagt`)
};

/**
* | output |
* | --- |
* | "Event canceled" |
*
* @param {Eventcanceled1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventcanceled1 = /** @type {((inputs?: Eventcanceled1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventcanceled1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventcanceled1(inputs)
	return de_eventcanceled1(inputs)
});
export { eventcanceled1 as "eventCanceled" }